import React from 'react';
import { painPoints } from '../data/content';
import { carouselOne } from '../data/carousels';
import { ProjectCarousel } from './ProjectCarousel';
import { RichText } from './RichText';
import { SectionHeading } from './SectionHeading';
export function ForYouSection() {
  return <section className="px-6 py-12" style={{
    marginTop: "-50px",
    marginBottom: "-50px"
  }} data-id="element-70" data-mp="2htb0buqxhaqq">
      <SectionHeading eyebrow="Succede anche a te?" data-id="element-71" data-mp="1l31t7obo2wqu">Questo Mega Kit fa per te se…</SectionHeading>

      <ul className="mt-7 space-y-5" data-id="element-72" data-mp="1p4ndvvug0fbl">
        {painPoints.map((line, index) => <li key={index} className="flex gap-3.5" data-id="element-73" data-mp="1p4x3hibkskgr" data-mpi={index}>
            <span className="mt-[11px] h-1.5 w-1.5 shrink-0 rounded-full bg-gold-400" aria-hidden="true" data-id="element-74" data-mp="1u36xvqph7h1b" />
            <p className="text-[16.5px] leading-[1.65] text-ink-800" data-id="element-75" data-mp="1z333fudtngiz">
              <RichText line={line} data-id="element-76" data-mp="35ivl8j6n6i2n" />
            </p>
          </li>)}
      </ul>

      <div className="-mx-6 mt-10" data-id="element-77" data-mp="35kzsnb3r1z7o">
        <ProjectCarousel images={carouselOne} direction="left" durationSeconds={38} data-id="element-78" data-mp="3ahgn0n1jl9t7" />
      </div>
    </section>;
}